import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiAnalyticsPlansCumulativeAnalysisIndexResponseType,
  ApiAnalyticsPlansCumulativeAnalysisIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiAnalyticsPlansCumulativeAnalysisIndexRequestType;
};

const request = async ({
  params,
}: RequestDataType): Promise<ApiAnalyticsPlansCumulativeAnalysisIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiAnalyticsPlansCumulativeAnalysisIndexResponseType>(
      "/api/analytics_plans/cumulative_analysis",
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiAnalyticsPlansCumulativeAnalysisIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAnalyticsPlansCumulativeAnalysisIndex = ({
  params,
  config = {},
}: PropsType = {}): UseQueryResult<ApiAnalyticsPlansCumulativeAnalysisIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAnalyticsPlansCumulativeAnalysisIndex", params],
    queryFn: () => request({ params }),
  });
};
